import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Usability.css'
import usabilityHero from "../../../assets/images/Usability Testing.png";
import usabilityResearch from "../../../assets/images/Usability Testing.png";

const UsabilityPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Usability Testing – BuddyTech Solutions </title>
        <meta name="description" content="Conduct usability tests to improve user satisfaction and task success." />
        <meta name="keywords" content="usability testing, UX research" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Usability Testing – BuddyTech Solutions" />
        <meta property="og:description" content="Conduct usability tests to improve user satisfaction and task success." />
        <meta property="og:keywords" content="usability testing, UX research" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/usability" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Usability Testing – BuddyTech Solutions" />
        <meta name="twitter:description" content="Conduct usability tests to improve user satisfaction and task success." />
        <meta name="twitter:keywords" content="usability testing, UX research" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="usability-container">
        <header className="usability-hero">
          <div className="usability-hero-content">
            <h1>Usability Testing & UX Audits</h1>
            <p>
              We identify friction points and improve the overall user experience through usability testing and UX audits backed by real user behavior.
            </p>
          </div>
          <img src={usabilityHero} alt="Usability Hero" className="usability-hero-img" />
        </header>

        <section className="usability-section">
          <div className="usability-text">
            <h2>How We Help</h2>
            <p>
              Through direct user feedback and task-based evaluations, we uncover barriers to conversion and usability flaws. Our recommendations are actionable and backed by research.
            </p>
            <ul>
              <li>Usability Testing (Remote & In-Person)</li>
              <li>Heuristic Evaluation</li>
              <li>Accessibility Checks</li>
              <li>UX Heatmaps & Session Recordings</li>
              <li>UX Audit Reports & Recommendations</li>
            </ul>
          </div>
          <img src={usabilityResearch} alt="User Research Insights" className="usability-img" />
        </section>

        <section className="usability-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>Maze</span>
            <span>Lookback</span>
            <span>Hotjar</span>
            <span>PlaybookUX</span>
            <span>UXCam</span>
            <span>Google Analytics</span>
            <span>Figma</span>
            <span>Microsoft Clarity</span>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default UsabilityPage;